<template>
	<!-- 头部整体盒子 -->
	<div id="header" class="container-fuild">
		<!-- 头部顶部 -->
		<div class="header-top container-fuild hidden-xs">
			<div class="container">
				<div class="server pull-left">
					<div class="web-index-top" style="cursor: pointer;" @click="$router.push(headerArticle.content1)">{{headerArticle.title || webIndexTop}}</div>
				</div>
				<div class="shejiao pull-right">
					<img src="@/assets/img/world.png" style="padding-right: 5px;" />
					<div v-for="(item, index) in languageList" :key="item.id" style="cursor: pointer;" @click="switchLanguage(item.value)">
						<span>{{item.name}}</span> 
						<span v-if="index < languageList.length - 1">|</span> 
					</div>
				</div>
			</div>
		</div>
		<div class="header-top container-fuild hidden-xs">
			<div class="" style="position: relative; height: 100%;">
				<img src="@/assets/img/top-bg.png" style="width: 100%; height: 100%;" />
				<div style="position: absolute; top: 0; width: 100%;">
					<div class="container">
						<div class="server pull-left" style="font-size: 15px; color: #e7ffff; cursor: pointer;" @click="$router.push(headerLeftArticle.content1)">
							{{headerLeftArticle.title || webIndexTopBannerLeft}}
						</div>
						<div class="shejiao pull-right" style="font-size: 15px; color: #fffefa; cursor: pointer;" @click="$router.push(headerRightArticle.content1)">
							{{headerRightArticle.title || webIndexTopBannerRight}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 电脑导航 -->
		<div class="header-nav container hidden-xs" style="display: flex; justify-content: space-between; align-items: center;">
			<!-- 导航logo -->
			<div class="header-nav-logo">
				<router-link to="/">
					<img src="@/assets/img/logo_black.png" style="width: 50%;" />
				</router-link>
			</div>
			<!-- 导航内容 -->
			<ul class="header-nav-wrapper">
				<li v-for="(item,index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
					@click="navClick(index, item.name)">
					<router-link :to="item.url">
						{{item.name}}
						<span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
						<i class="underline"></i>
					</router-link>
					<dl v-if="item.children.length > 0">
						<dt v-for="(i, n) in item.children" :key="n">
							<router-link :to="i.url">{{i.name}}</router-link>
						</dt>
					</dl>
				</li>
			</ul>
			<!-- 立即咨询 -->
			<router-link to="/contactus">
				<div class="header-nav-consult">
					{{getConstant('CONSULT_IMMEDIATELY')}}
				</div>
			</router-link>
		</div>
		<!-- 手机导航 -->
		<div class="header-nav-m container-fuild visible-xs">
			<div class="header-nav-m-logo" v-if="!isPoster">
				<!-- 导航栏 -->
				<div class="header-nav-m-menu text-center">
					<div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
						<span :class="menuClass"></span>
					</div>
					<!-- 导航内容 -->
					<ul id="menu" class="header-nav-m-wrapper collapse">
						<li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
							@click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
							<router-link :to="item.url">
								{{item.name}}
								<i class="underline"></i>
							</router-link>
						</li>
						<li v-for="(item, index) in languageList" :key="item.id" style="cursor: pointer;" @click="switchLanguage(item.value)">
							{{item.name}}
						</li>
					</ul>
				</div>
				<router-link to="/" style="margin: auto;"><img class="center-block" src="@/assets/img/logo_black.png" alt="logo"></router-link>
				<!-- 立即咨询 -->
				<div class="header-nav-consult">
					<router-link to="/contactus" style="color: #FFF;">
						{{getConstant('CONSULT_IMMEDIATELY')}}
					</router-link>
				</div>
			</div>
			<div class="header-nav-m-logo" v-else>
				<router-link to="/poster" style="margin-left: 10px;"><img class="center-block" src="@/assets/img/logo_black.png" alt="logo"></router-link>
			</div>
		</div>
	</div>
</template>
<script>
	import { getConstant, getLanguageList, getConfigValue, getChannelList, getNewsList } from '@/api/api';
	export default {
		name: "Header",
		data() {
			return {
				languageList: [], // 语言列表
				webIndexTop: '',	// WEB端首页顶部文字
				headerArticle: {},	// WEB端首页顶部文字
				webIndexTopBannerLeft: '', // WEB端首页顶部横幅左侧文字
				headerLeftArticle: {},	// WEB端首页顶部横幅左侧文字
				webIndexTopBannerRight: '', // WEB端首页顶部横幅右侧文字
				headerRightArticle: {},	// WEB端首页顶部横幅右侧文字
				navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
				menuName: "首页",
				menuClass: "glyphicon glyphicon-list",
				navList: [],
				isPoster: false
			};
		},
		created() {
			console.log('header');
			let that = this;
			
			that.code = that.$route.query.code || '';
			if(that.code) {
				// let time = new Date();
				// sessionStorage.setItem('source-code' + time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate(), that.code);
				sessionStorage.setItem('source-code', that.code);
			}
			
			getLanguageList(function(list) {
				that.languageList = list;
			});
			getConfigValue('WEB_INDEX_TOP', function(info) {
				that.webIndexTop = info;
			});
			getNewsList({tags: 8}, function(list) {
				if(list != null && list.length > 0) {
					that.headerArticle = list[0];
				}
			});
			getConfigValue('WEB_INDEX_TOP_BANNER_LEFT', function(info) {
				that.webIndexTopBannerLeft = info;
			});
			getNewsList({tags: 9}, function(list) {
				if(list != null && list.length > 0) {
					that.headerLeftArticle = list[0];
				}
			});
			getConfigValue('WEB_INDEX_TOP_BANNER_RIGHT', function(info) {
				that.webIndexTopBannerRight = info;
			});
			getNewsList({tags: 10}, function(list) {
				if(list != null && list.length > 0) {
					that.headerRightArticle = list[0];
				}
			});
			getChannelList({type: 1}, function(list) {
				list.sort(function(a, b){
				    return a.sort - b.sort;
				});
				for(let i in list) {
					list[i].children = list[i].children || [];
					list[i].children.sort(function(a, b){
						return a.sort - b.sort;
					});
				}
				that.navList = list;
			});
			
			let currentPath = window.location.hash;
			if(currentPath.indexOf("poster") > -1) {
				that.isPoster = true;
			}
		},
		methods: {
			getConstant,
			navClick(index, name) {
				this.navIndex = index;
				sessionStorage.setItem('navIndex', index)
				this.menuName = name;
			},
			menuClick() {
				// if (this.menuClass == "glyphicon glyphicon-menu-down") {
				// 	this.menuClass = "glyphicon glyphicon-menu-up";
				// } else {
				// 	this.menuClass = "glyphicon glyphicon-menu-down";
				// }
			},
			// 切换语言
			switchLanguage: function(language) {
				sessionStorage.setItem('language', language);
				window.location.reload();
			}
		}
	};
</script>
<style scoped>
	/* 顶部 */
	#header {
		transition: all ease 0.6s;
	}

	#header .header-top {
		height: 40px;
		color: #fff;
		font-size: 12px;
		line-height: 50px;
		background: #FFFFFF;
	}

	/* 顶部的图片 */
	#header .header-top .pull-left, #header .header-top .pull-right {
		height: 40px;
		display: flex;
		align-items: center;
		color: #000;
	}
	
	#header .header-top .web-index-top {
		background: #84D3F7; border-radius: 16px; border: 1px solid #84D3F7; padding: 0 18px; font-family: MicrosoftYaHei; font-size: 20px; color: #FFFFFF; text-shadow: 2px 0px 4px #000000; text-align: left; font-style: normal; text-transform: none;
		line-height: 33px;
		height: 33px;
	}

	/* 顶部的文字 */
	#header .header-top span {
		margin: 0 2px;
		font-weight: 600;
	}

	/* 导航栏 */
	#header .header-nav {
		height: 110px;
	}

	/* 导航栏 */
	#header .header-nav.container:before, #header .header-nav.container:after {
		display: none;
	}

	/* 导航栏 导航容器 */
	#header .header-nav-fixed .header-nav-wrapper {
		line-height: 50px;
	}

	#header .header-nav .header-nav-wrapper {
		line-height: 110px;
		float: right;
		margin: 0;
		max-width: 800px;
	}

	/* 导航栏 每个导航 */
	#header .header-nav .header-nav-wrapper>li {
		float: left;
		margin: 0 15px;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接 */
	#header .header-nav .header-nav-wrapper>li>a {
		color: #6d6d6d;
		font-size: 18px;
		font-weight: bold;
		padding: 15px 0 5px;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接的下划线 */
	#header .header-nav .header-nav-wrapper>li>a>i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		width: 0;
		height: 2px;
		opacity: 0;
		transition: all 0.6s ease;
		background-color: #4e96d1;
	}

	/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
	#header .header-nav .header-nav-wrapper>li>a>span {
		font-size: 12px;
		transition: transform ease 0.5s;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover {
		color: #4e96d1;
		text-decoration: none;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover .underline {
		opacity: 1;
		width: 100%;
		left: 0;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover span {
		transform: rotate(180deg);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	#header .header-nav .header-nav-wrapper>li.active>a {
		color: #1e73be;
		text-decoration: none;
		border-bottom: 2px solid #1e73be;
	}

	/* 导航栏 每个导航下面的二级导航容器 */
	#header .header-nav .header-nav-wrapper>li>dl {
		display: none;
		position: absolute;
		width: 168px;
		top: 80%;
		left: 0;
		z-index: 999999;
		box-shadow: 0 0 3px 1px #ccc;
		background: #fff;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 */
	#header .header-nav .header-nav-wrapper>li>dl>dt {
		width: 100%;
		padding: 10px;
		border-bottom: 1px solid #ccc;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
	#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
		text-decoration: none;
	}

	/* 导航栏 滑上一级导航显示二级导航 */
	#header .header-nav .header-nav-wrapper>li:hover dl {
		display: block;
	}

	#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
		cursor: pointer;
		background: #ccc;
	}

	/* 导航栏 导航容器 */
	#header .header-nav .header-nav-consult {
		width: 100px;
		text-align: center;
		line-height: 40px;
		float: right;
		background-color: #4e96d1;
		color: #FFFFFF;
	}

	@media screen and (max-width: 997px) {
		#header .header-nav-m {
			
		}

		/* 导航栏logo容器 */
		#header .header-nav-m .header-nav-m-logo {
			height: 72px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			position: relative;
		}

		/* 导航栏logo图片 */
		#header .header-nav-m .header-nav-m-logo img {
			width: 100px;
		}

		/* 导航栏  菜单容器 */
		#header .header-nav-m .header-nav-m-menu {
			color: #fff;
			height: 50px;
			font-size: 20px;
			line-height: 50px;
			position: absolute;
		}

		/* 导航栏 菜单图标 */
		#header .header-nav-m .header-nav-m-menu-wrapper {
			width: 50px;
			height: 40px;
			color: #4E96D1;
			z-index: 999999;
			font-size: 23px;
		}

		/* 导航栏 */
		#header .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 50px;
			left: 0;
			width: 30vw;
			background: #474747;
			z-index: 9999999;
		}

		/* 导航栏 每个导航 */
		#header .header-nav-m .header-nav-m-wrapper>li {
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #ccc;
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header .header-nav-m .header-nav-m-wrapper>li>a {
			color: #fff;
			font-size: 15px;
			font-weight: bold;
			padding: 15px 0;
			position: relative;
		}
		
		#header .header-nav-m  .header-nav-consult {
			position: absolute;
			right: 10px;
			font-size: 12px;
			width: auto!important;
			padding: 0 10px;
		}

		/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
		#header .header-nav .header-nav-wrapper>li>a>span {
			font-size: 10px;
		}

		/* 导航栏 导航容器 */
		#header .header-nav-m .header-nav-consult {
			width: 100px;
			text-align: center;
			line-height: 40px;
			background-color: #4e96d1;
			color: #FFFFFF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue